module.exports = __webpack_public_path__ + "static/media/wrinkles-lines.1fc4bdcc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/instore/icons/wrinkles-lines.svg
// module id = 155
// module chunks = 0